export default __webpack_public_path__ + "static/media/limit_fusindo.77a455ee.svg";